import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as jobTitles from '../../../../job-titles'
import * as stakeholder from '../stakeholder'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: stakeholder.RESOURCE.payload.dimension.partialId,
      partialId: stakeholder.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: "Employee's job title or role.",
    isOptional: true,
    name: 'Job Title',
    partialId: PartialId.Standard.create('job_title'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        jobTitles.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
